import { useState, useCallback } from "react";
import type { Phase } from "../../types";

/**
 * Hook to manage AI phase simulation transitions.
 */
export function usePhaseSimulation() {
  const [phase, setPhase] = useState<Phase>("analyzing");

  const startPhaseSimulation = useCallback(() => {
    setPhase("analyzing");

    const timers = [
      setTimeout(() => setPhase("searching"), 1200),
      setTimeout(() => setPhase("drafting"), 3400),
      setTimeout(() => setPhase("verifying"), 5600),
    ];

    return () => timers.forEach(clearTimeout);
  }, []);

  return { phase, setPhase, startPhaseSimulation };
}
